<template>
  <div class="my" :class="{ 'my not-expanded': !expanded }">
    <header class="my-header">
      <span
        v-if="from_number || to_number"
        @click="deleteValue"
        class="my-header-icon-remove filter-trash cursor_pointer"
      >
        <mdicon name="trash-can-outline" size="18" />
      </span>
      <p @click="toggleCardState" class="my-header-title pl-1">
        <span
          class="text-primary pr-1"
          :class="{ 'ml-4': from_number || to_number }"
          v-b-tooltip.hover
          :title="header.search_scope"
        >
          <mdicon
            v-if="header.search_scope"
            name="information"
            class="information-icon"
            size="20"
          />
          <mdicon v-else name="checkbox-blank-circle-outline" size="20" />
        </span>
        <span class="pr-1">
          {{ header.key_filter_caption }}
        </span>
      </p>
      <a @click="toggleCardState" class="my-header-icon">
        <span class="icon">
          <i class="fa fa-angle-up"></i>
        </span>
      </a>
    </header>

    <div class="my-content">
      <div class="content p-2">
        <b-form-group label-for="timeing" :label-cols="$config.form.labelCol">
          <selectFind
            :options="timeing_options"
            v-model="timeing_selected"
            label="text"
            id="value"
            :loading="timeing_Loading"
            @input="changingStructure"
          />
        </b-form-group>
        <b-form-group
          :label="$lang.number"
          label-for="credit_end_date"
          :label-cols="12"
        >
          <b-input-group>
            <b-form-input
              :type="header.type"
              v-model="from_number"
              @input="delay(changeDate)"
            >
            </b-form-input>
            <span v-if="from_number" @click="deleteValue">
              <i class="fa fa-times remove_value" aria-hidden="true"></i>
            </span>
          </b-input-group>
        </b-form-group>
        <b-form-group
          v-if="timeing_selected && timeing_selected.value == `between`"
          :label="$lang.to_number"
          label-for="credit_end_date"
          :label-cols="12"
        >
          <b-input-group>
            <b-form-input
              :type="header.type"
              v-model="to_number"
              @input="delay(changeDate)"
            >
            </b-form-input>
            <span v-if="from_number" @click="deleteValue">
              <i class="fa fa-times remove_value" aria-hidden="true"></i>
            </span>
          </b-input-group>
        </b-form-group>
        <button
          v-if="timeing_selected && timeing_selected.value == `between`"
          class="btn btn-primary w-100 my-2"
          @click="actionBetween"
        >
          {{ $lang.btn_date }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    expandAll: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Object,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      result: this.value,
      expanded: false,
      from_number: null,
      to_number: null,
      timeing_Loading: false,
      timeing_selected: {
        value: "eq",
        text: " مساوی",
      },
      timeing_options: [
        {
          value: "eq",
          text: " مساوی",
        },
        {
          value: "between",
          text: "مابین",
        },
        {
          value: "gt",
          text: "بزرگتر ",
        },
        {
          value: "lt",
          text: "کوچکتر",
        },
        {
          value: "gte",
          text: "بزرگتر مساوی",
        },
        {
          value: "lte",
          text: "کوچکتر مساوی",
        },
      ],
      timer: null,
    };
  },
  watch: {
    value(newValue) {
      this.result = newValue;
    },
  },
  created() {
    this.$on("closeAll", this.closeAll);
    this.fetchData();
  },
  methods: {
    toggleCardState() {
      this.expanded = !this.expanded;
      if (this.expanded) this.$emit("getData", this.header);
    },
    closeAll() {
      this.expanded = false;
    },
    fetchData() {
      if (this.result.length) {
        const timeing = this.result[0];
        this.from_number = this.result[1];
        this.to_number = this.result[2];
        this.timeing_selected = this.timeing_options.find(
          (x) => x.value == timeing
        );
      }
    },
    changeDate() {
      if (this.from_number && this.timeing_selected.value !== "between") {
        this.$emit(
          "numberSelected",
          this.header.key_service,
          this.timeing_selected.value,
          this.from_number,
          this.to_number
        );
      }
    },
    deleteValue() {
      this.from_number = null;
      this.to_number = null;
      this.timeing_selected = {
        value: "eq",
        text: " مساوی",
      };
      this.$emit(
        "numberSelected",
        this.header.key_service,
        this.timeing_selected.value,
        this.from_number,
        this.to_number
      );
      this.expanded = false;
    },
    actionBetween() {
      if (this.from_number && this.to_number)
        this.$emit(
          "numberSelected",
          this.header.key_service,
          this.timeing_selected.value,
          this.from_number,
          this.to_number
        );
      else this.$notify.error(this.$lang.error_number_field_between);
    },
    changingStructure() {
      if (
        (this.from_number || this.to_number) &&
        this.timeing_selected !== "between"
      )
        this.$emit(
          "dateSelected",
          this.header.key_service,
          this.timeing_selected.value,
          this.from_number,
          this.to_number
        );
      this.delay(this.changeDate());
    },
    delay(callback) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(callback, 800);
    },
    clearAllData() {
      this.restult = [];
      this.from_number = null;
      this.to_number = null;
      this.closeAll();
    },
  },
};
</script>
<style lang="scss" scoped>
.remove_value {
  left: 15px;
  z-index: 1;
}
</style>
